module.exports = "#inlineFormSearch{width:100%}\n"